import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const documentRelationsService = {
  get,
  add,
  del
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  }
};
function extract(r) {
  return r.data;
}

async function get(documentVersionCode) {
  return axios.get(model.baseUrl + 'DocumentRelations/Get/' + documentVersionCode).then(extract);
}

async function add(documentVersionCode, related) {
  return axios
    .post(model.baseUrl + 'DocumentRelations/Add', {
      documentVersionCode: documentVersionCode,
      relatedDocumentVersionCode: related
    })
    .then(extract);
}

async function del(relationIds) {
  return axios.post(model.baseUrl + 'DocumentRelations/Del', relationIds).then(extract);
}
